var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.checkClient($event)}}},[_vm._t("default",[_vm._v("\n      "+_vm._s(_vm.$t('common.post_job'))+"\n    ")])],2)])}
var staticRenderFns = []

export { render, staticRenderFns }